<template>
    <div>
        <AppHeader :hideCenterMenu="true" :hideSideMenu="true"></AppHeader>
        <notifications group="form" class="mt-1" style="top: 100px;"/>
        <div class="container">
            <div class="row mt-5 pt-5 justify-content-center">
                <div class="col-12 d-flex justify-content-center m-3" v-if="loading">
                    <b-spinner label="Loading..."></b-spinner>
                </div>
                <div class="col-xl-8 col-sm-12 d-flex justify-content-center m-3" v-else-if="error">
                    <div class="alert alert-danger w-100" role="alert">{{ $t(error) }}</div>
                </div>
                <div v-else class="col-xl-8 col-sm-12">
                    <div class="card-widget">
                        <div class="card-widget-title">
                            <div class="card-widget-title-label">
                                <h3>{{$t('Account On-Boarding')}}</h3>
                            </div>
                        </div>
                        <div class="card-widget-content">
                            <div class="d-flex justify-content-center m-3" v-if="loading">
                                <b-spinner label="Loading..."></b-spinner>
                            </div>
                            <div v-else>
                                <b-form-group :label="$t('Name')" label-for="name" :feedback="$validator.errors.first('name')">
                                    <b-form-input
                                        type="text"
                                        id="name"
                                        name="name"
                                        :disabled="submitting"
                                        v-model='user.name'
                                        v-validate="'required'"
                                        :data-vv-as="$t('Name')"
                                        :state="validationState('name')"
                                        :class="{ 'control': true }">
                                    </b-form-input>
                                </b-form-group>

                                <b-form-group :label="$t('Surname')" label-for="surname" :feedback="$validator.errors.first('surname')">
                                    <b-form-input
                                        type="text"
                                        id="surname"
                                        name="surname"
                                        :disabled="submitting"
                                        v-model='user.surname'
                                        v-validate="'required'"
                                        :data-vv-as="$t('Surname')"
                                        :state="validationState('surname')"
                                        :class="{ 'control': true }"></b-form-input>
                                </b-form-group>

                                <b-form-group :label="$t('Email')" label-for="email" :feedback="$validator.errors.first('email')">
                                    <b-form-input
                                        type="text"
                                        id="email"
                                        name="email"
                                        :placeholder="$t('Email').toLowerCase()"
                                        v-model='user.email'
                                        :data-vv-as="$t('Email')"
                                        :disabled="true"
                                        :class="{ 'control': true }"></b-form-input>
                                </b-form-group>

                                <div class="form-group mb-5">
                                    <div class="row">
                                        <div class="col-md-6">
                                            <b-form-group :label="$t('Password')"
                                                          label-for="password"
                                                          :feedback="$validator.errors.first('password')"
                                                          class="mb-3">
                                                <b-form-input
                                                    type="password"
                                                    id="password"
                                                    name="password"
                                                    ref="password"
                                                    :disabled="submitting"
                                                    v-model='user.password'
                                                    v-validate="'required|min:8'"
                                                    :data-vv-as="$t('Password')"
                                                    :state="validationState('password')"
                                                />
                                            </b-form-group>
                                        </div>
                                        <div class="col-md-6">
                                            <b-form-group :label="$t('Password confirm')"
                                                          label-for="passwordConfirm"
                                                          :feedback="$validator.errors.first('passwordConfirm')"
                                                          class="mb-3">
                                                <b-form-input
                                                    type="password"
                                                    id="passwordConfirm"
                                                    name="passwordConfirm"
                                                    :disabled="submitting"
                                                    v-model='user.password_confirmation'
                                                    v-validate="'required|min:8|confirmed:password'"
                                                    :data-vv-as="$t('passwordConfirm')"
                                                    :state="validationState('passwordConfirm')"
                                                />
                                            </b-form-group>
                                        </div>
                                    </div>
                                    <b-form-group :label="$t('Language')">
                                        <b-form-select v-model="user.language_id" @change="changeLanguage">
                                            <option v-for="language in languages" :value="language.id" :key="language.id">
                                                {{language.name}}
                                            </option>
                                        </b-form-select>
                                    </b-form-group>
                                </div>
                                <div  class="text-right">
                                    <b-form-group>
                                        <button type="button" class="btn btn-primary btn-block-sm-down" :disabled="submitting" @click="validateBeforeSubmit" v-t="'Confirm'"></button>
                                    </b-form-group>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <AppFooter></AppFooter>
    </div>
</template>

<script>
import axios from 'axios'
import apiHelpers from "../../../js/services/apiHelpers";
import {Footer as AppFooter, Header as AppHeader, Sidebar} from "../../../components";
import {error} from "../../../js/services/notifyMessages";

export default {
    name: 'OnBoarding',
    components: {
        AppHeader,
        Sidebar,
        AppFooter,
    },
    mixins: [apiHelpers],
    data() {
        return {
            loading: true,
            submitting: false,
            error: false,
            languages: [],
            user: {
                name: null,
                surname: null,
                email: null,
                password: null,
                password_confirmation: null,
                language_id: null,
            },
            login_url: null,
        }
    },
    async mounted() {
        this.validateToken();
        this.getLanguages();
    },
    computed: {},
    methods: {
        validateBeforeSubmit() {
            this.submitting = true;
            const token = this.$route.query.token;

            // Validate token server side
            let url = `${this.$store.getters.getAppUrl}/customer/api/v2/user-on-boarding?token=${token}`
            axios.post(url, this.user, { errorHandle: false })
                .then(() => {
                    this.redirectToLogin();
                })
                .catch((err) => {
                    this.$notify(error(err.response.data.message));
                    this.submitting = false;
                })
        },
        changeLanguage() {
            const language = this.languages.find(l => l.id === this.user.language_id);
            this.$store.dispatch('account/updateLanguage', language.code);
        },
        redirectToLogin() {
            const user_language = this.$store.getters['account/language'].code;
            const user_group = this.$store.getters['account/group'];
            window.location = `/${user_language}/${user_group}/login`;
        },
        getLanguages: function () {
            const url = `${this.$store.getters.getAppUrl}/customer/api/v2/languages`;

            axios.get(url).then((response) => {
                this.languages = response.data.data;
            }).catch((error) => {});
        },
        validateToken() {
            this.loading = true;
            const token = this.$route.query.token;

            // Check if token has not been provided
            if (!token) this.redirectToLogin();

            // Validate token server side
            let url = `${this.$store.getters.getAppUrl}/customer/api/v2/user-on-boarding?token=${token}`
            axios.get(url, { errorHandle: false })
                .then(({ data }) => {
                    this.user.email = data.email;
                    this.user.language_id = data.language_id;
                    this.loading = false;
                })
                .catch((err) => {
                    this.error = err.response.data.message;
                    this.loading = false;
                });
        },
    }
}
</script>
